import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createBlock(_component_button_dropdown, {
    title: "Выберите действие",
    class: "ml-2",
    placement: "bottom",
    "allowed-placements": ['bottom']
  }, {
    default: _withCtx(() => [
      (_ctx.isCanEditOrder)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/order/${_ctx.$route.params.order_id}/update-services`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, { class: "primary text small" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Редактировать доп. услуги ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      (_ctx.isCanEditOrder)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: `/order/${_ctx.$route.params.order_id}/edit`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, { class: "primary text small" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Редактировать заказ ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_button, {
        class: "primary text small",
        onClick: _ctx.emitPrintOrder,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Печать ")
        ]),
        _: 1
      }, 8, ["onClick", "loading"]),
      (_ctx.isCanChangeDate)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 2,
            class: "primary text small",
            onClick: _ctx.emitChangeDate
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Перенести забор ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isCanConfirmDate)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 3,
            class: "primary text small",
            onClick: _ctx.emitConfirmDate
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Подтвердить перенос забора ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isCanCancelOrder)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 4,
            class: "red text small",
            loading: _ctx.state.is_cancelling,
            onClick: _ctx.cancelOrder
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Отменить заказ ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}